import { transformError as sdkTransformError } from '@wix/sdk-runtime/transform-error';
import { renameKeysFromSDKRequestToRESTRequest, renameKeysFromRESTResponseToSDKResponse, } from '@wix/sdk-runtime/rename-all-nested-keys';
import * as ambassadorWixEcomV1Cart from './ecom-v1-cart-cart.http.js';
import { transformSDKAddressToRESTAddress } from '@wix/sdk-runtime/transformations/address';
import { transformRESTAddressToSDKAddress } from '@wix/sdk-runtime/transformations/address';
import { transformSDKImageToRESTImage } from '@wix/sdk-runtime/transformations/image';
import { transformRESTImageToSDKImage } from '@wix/sdk-runtime/transformations/image';
import { transformSDKPageURLV2ToRESTPageURLV2 } from '@wix/sdk-runtime/transformations/page-url-v2';
import { transformRESTPageURLV2ToSDKPageURLV2 } from '@wix/sdk-runtime/transformations/page-url-v2';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
export var DescriptionLineType;
(function (DescriptionLineType) {
    /** Unrecognized type. */
    DescriptionLineType["UNRECOGNISED"] = "UNRECOGNISED";
    /** Plain text type. */
    DescriptionLineType["PLAIN_TEXT"] = "PLAIN_TEXT";
    /** Color type. */
    DescriptionLineType["COLOR"] = "COLOR";
})(DescriptionLineType || (DescriptionLineType = {}));
export var ItemAvailabilityStatus;
(function (ItemAvailabilityStatus) {
    ItemAvailabilityStatus["AVAILABLE"] = "AVAILABLE";
    /** Item does not exist. */
    ItemAvailabilityStatus["NOT_FOUND"] = "NOT_FOUND";
    /** Item is not in stock. */
    ItemAvailabilityStatus["NOT_AVAILABLE"] = "NOT_AVAILABLE";
    /** Available quantity is less than requested. */
    ItemAvailabilityStatus["PARTIALLY_AVAILABLE"] = "PARTIALLY_AVAILABLE";
})(ItemAvailabilityStatus || (ItemAvailabilityStatus = {}));
export var ItemTypeItemType;
(function (ItemTypeItemType) {
    ItemTypeItemType["UNRECOGNISED"] = "UNRECOGNISED";
    ItemTypeItemType["PHYSICAL"] = "PHYSICAL";
    ItemTypeItemType["DIGITAL"] = "DIGITAL";
    ItemTypeItemType["GIFT_CARD"] = "GIFT_CARD";
    ItemTypeItemType["SERVICE"] = "SERVICE";
})(ItemTypeItemType || (ItemTypeItemType = {}));
/** Frequency unit of recurring payment */
export var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["UNDEFINED"] = "UNDEFINED";
    SubscriptionFrequency["DAY"] = "DAY";
    SubscriptionFrequency["WEEK"] = "WEEK";
    SubscriptionFrequency["MONTH"] = "MONTH";
    SubscriptionFrequency["YEAR"] = "YEAR";
})(SubscriptionFrequency || (SubscriptionFrequency = {}));
export var FileType;
(function (FileType) {
    FileType["UNSPECIFIED"] = "UNSPECIFIED";
    FileType["SECURE_PICTURE"] = "SECURE_PICTURE";
    FileType["SECURE_VIDEO"] = "SECURE_VIDEO";
    FileType["SECURE_DOCUMENT"] = "SECURE_DOCUMENT";
    FileType["SECURE_MUSIC"] = "SECURE_MUSIC";
    FileType["SECURE_ARCHIVE"] = "SECURE_ARCHIVE";
})(FileType || (FileType = {}));
/** Type of selected payment option for catalog item */
export var PaymentOptionType;
(function (PaymentOptionType) {
    /** The entire payment for this item happens as part of the checkout. */
    PaymentOptionType["FULL_PAYMENT_ONLINE"] = "FULL_PAYMENT_ONLINE";
    /** The entire payment for this item happens after checkout. For example, when using cash, check, or other offline payment methods. */
    PaymentOptionType["FULL_PAYMENT_OFFLINE"] = "FULL_PAYMENT_OFFLINE";
    /** Payment for this item is done by charging a membership. When selected, `price` is `0`. */
    PaymentOptionType["MEMBERSHIP"] = "MEMBERSHIP";
    /** Partial payment to be paid upfront during checkout. The initial amount to be paid for each line item is specified in `depositAmount`. */
    PaymentOptionType["DEPOSIT_ONLINE"] = "DEPOSIT_ONLINE";
    /** Payment for this item can only be done by charging a membership and must be manually redeemed in the dashboard by the site admin. When selected, `price` is `0`. */
    PaymentOptionType["MEMBERSHIP_OFFLINE"] = "MEMBERSHIP_OFFLINE";
})(PaymentOptionType || (PaymentOptionType = {}));
export var TaxableAddressType;
(function (TaxableAddressType) {
    TaxableAddressType["UNKNOWN_TAXABLE_ADDRESS"] = "UNKNOWN_TAXABLE_ADDRESS";
    TaxableAddressType["BUSINESS"] = "BUSINESS";
    TaxableAddressType["BILLING"] = "BILLING";
    TaxableAddressType["SHIPPING"] = "SHIPPING";
})(TaxableAddressType || (TaxableAddressType = {}));
export var WeightUnit;
(function (WeightUnit) {
    /** Weight unit can't be classified due to an error. */
    WeightUnit["UNSPECIFIED_WEIGHT_UNIT"] = "UNSPECIFIED_WEIGHT_UNIT";
    /** Kilograms. */
    WeightUnit["KG"] = "KG";
    /** Pounds. */
    WeightUnit["LB"] = "LB";
})(WeightUnit || (WeightUnit = {}));
export var DiscountType;
(function (DiscountType) {
    /** "GLOBAL" - discount applies to entire order. */
    DiscountType["GLOBAL"] = "GLOBAL";
    /** "SPECIFIC-ITEMS" - discount applies to specific items. */
    DiscountType["SPECIFIC_ITEMS"] = "SPECIFIC_ITEMS";
    /** "SHIPPING" - discount applies to shipping. For example, free shipping. */
    DiscountType["SHIPPING"] = "SHIPPING";
})(DiscountType || (DiscountType = {}));
/** tax info types */
export var VatType;
(function (VatType) {
    VatType["UNSPECIFIED"] = "UNSPECIFIED";
    /** CPF - for individual tax payers. */
    VatType["CPF"] = "CPF";
    /** CNPJ - for corporations */
    VatType["CNPJ"] = "CNPJ";
})(VatType || (VatType = {}));
/** JurisdictionType represents the type of the jurisdiction in which this tax detail applies (e.g. Country,State,County,City,Special). */
export var JurisdictionType;
(function (JurisdictionType) {
    JurisdictionType["UNDEFINED"] = "UNDEFINED";
    JurisdictionType["COUNTRY"] = "COUNTRY";
    JurisdictionType["STATE"] = "STATE";
    JurisdictionType["COUNTY"] = "COUNTY";
    JurisdictionType["CITY"] = "CITY";
    JurisdictionType["SPECIAL"] = "SPECIAL";
})(JurisdictionType || (JurisdictionType = {}));
export var RateType;
(function (RateType) {
    /** no tax being collected for this request due to location of purchase */
    RateType["NO_TAX_COLLECTED"] = "NO_TAX_COLLECTED";
    /** manual rate used for calculation */
    RateType["MANUAL_RATE"] = "MANUAL_RATE";
    /** autotax rate used for calculation */
    RateType["AUTO_RATE"] = "AUTO_RATE";
    /** fallback rate used for calculation */
    RateType["FALLBACK_RATE"] = "FALLBACK_RATE";
})(RateType || (RateType = {}));
export var ManualCalculationReason;
(function (ManualCalculationReason) {
    /** user set calculator in Business Manager to be Manual */
    ManualCalculationReason["GLOBAL_SETTING_TO_MANUAL"] = "GLOBAL_SETTING_TO_MANUAL";
    /** specific region is on manual even though Global setting is Auto-tax */
    ManualCalculationReason["REGION_SETTING_TO_MANUAL"] = "REGION_SETTING_TO_MANUAL";
})(ManualCalculationReason || (ManualCalculationReason = {}));
export var FallbackReason;
(function (FallbackReason) {
    /** auto-tax failed to be calculated */
    FallbackReason["AUTO_TAX_FAILED"] = "AUTO_TAX_FAILED";
    /** auto-tax was temporarily deactivated on a system-level */
    FallbackReason["AUTO_TAX_DEACTIVATED"] = "AUTO_TAX_DEACTIVATED";
})(FallbackReason || (FallbackReason = {}));
export var PickupMethod;
(function (PickupMethod) {
    PickupMethod["UNKNOWN_METHOD"] = "UNKNOWN_METHOD";
    PickupMethod["STORE_PICKUP"] = "STORE_PICKUP";
    PickupMethod["PICKUP_POINT"] = "PICKUP_POINT";
})(PickupMethod || (PickupMethod = {}));
export var ChargeType;
(function (ChargeType) {
    ChargeType["HANDLING_FEE"] = "HANDLING_FEE";
    ChargeType["INSURANCE"] = "INSURANCE";
})(ChargeType || (ChargeType = {}));
export var AppliedDiscountDiscountType;
(function (AppliedDiscountDiscountType) {
    AppliedDiscountDiscountType["GLOBAL"] = "GLOBAL";
    AppliedDiscountDiscountType["SPECIFIC_ITEMS"] = "SPECIFIC_ITEMS";
    AppliedDiscountDiscountType["SHIPPING"] = "SHIPPING";
})(AppliedDiscountDiscountType || (AppliedDiscountDiscountType = {}));
export var RuleType;
(function (RuleType) {
    RuleType["VALIDATION"] = "VALIDATION";
    RuleType["OTHER"] = "OTHER";
    RuleType["MAX"] = "MAX";
    RuleType["MIN"] = "MIN";
    RuleType["MAX_LENGTH"] = "MAX_LENGTH";
    RuleType["MIN_LENGTH"] = "MIN_LENGTH";
    RuleType["MAX_SIZE"] = "MAX_SIZE";
    RuleType["MIN_SIZE"] = "MIN_SIZE";
    RuleType["FORMAT"] = "FORMAT";
    RuleType["DECIMAL_LTE"] = "DECIMAL_LTE";
    RuleType["DECIMAL_GTE"] = "DECIMAL_GTE";
    RuleType["DECIMAL_LT"] = "DECIMAL_LT";
    RuleType["DECIMAL_GT"] = "DECIMAL_GT";
    RuleType["DECIMAL_MAX_SCALE"] = "DECIMAL_MAX_SCALE";
    RuleType["INVALID_ENUM_VALUE"] = "INVALID_ENUM_VALUE";
    RuleType["REQUIRED_FIELD"] = "REQUIRED_FIELD";
    RuleType["FIELD_NOT_ALLOWED"] = "FIELD_NOT_ALLOWED";
    RuleType["ONE_OF_ALIGNMENT"] = "ONE_OF_ALIGNMENT";
    RuleType["EXACT_LENGTH"] = "EXACT_LENGTH";
    RuleType["EXACT_SIZE"] = "EXACT_SIZE";
    RuleType["REQUIRED_ONE_OF_FIELD"] = "REQUIRED_ONE_OF_FIELD";
})(RuleType || (RuleType = {}));
export var AdditionalFeeSource;
(function (AdditionalFeeSource) {
    AdditionalFeeSource["UNKNOWN_ADDITIONAL_FEE_SOURCE"] = "UNKNOWN_ADDITIONAL_FEE_SOURCE";
    /** The additional fee was added by an additional fee service plugin */
    AdditionalFeeSource["SERVICE_PLUGIN"] = "SERVICE_PLUGIN";
    /** The additional fee was added on the item either via the catalog or on custom line item */
    AdditionalFeeSource["ITEM"] = "ITEM";
    /** The additional fee was added manually on the request */
    AdditionalFeeSource["MANUAL"] = "MANUAL";
})(AdditionalFeeSource || (AdditionalFeeSource = {}));
export var Severity;
(function (Severity) {
    /** The user is allowed to move forward in the flow. */
    Severity["WARNING"] = "WARNING";
    /**
     * The user is blocked from moving forward in the flow.
     * For example, if callerContext is CART - moving to checkout is blocked. if callerContext is CHECKOUT, placing an order is blocked.
     */
    Severity["ERROR"] = "ERROR";
})(Severity || (Severity = {}));
/** Available locations on the webpage */
export var NameInOther;
(function (NameInOther) {
    /** Default location, in case no specific location is specified. */
    NameInOther["OTHER_DEFAULT"] = "OTHER_DEFAULT";
})(NameInOther || (NameInOther = {}));
/** Available locations on the line item */
export var NameInLineItem;
(function (NameInLineItem) {
    /** Default location, in case no specific location is specified. */
    NameInLineItem["LINE_ITEM_DEFAULT"] = "LINE_ITEM_DEFAULT";
})(NameInLineItem || (NameInLineItem = {}));
export var SuggestedFix;
(function (SuggestedFix) {
    /** No suggested fix is specified. The user should refer to the violation description to resolve the issue. */
    SuggestedFix["UNKNOWN_SUGGESTED_FIX"] = "UNKNOWN_SUGGESTED_FIX";
    /** The line item should be removed from the cart or checkout to resolve the violation. */
    SuggestedFix["REMOVE_LINE_ITEM"] = "REMOVE_LINE_ITEM";
})(SuggestedFix || (SuggestedFix = {}));
export var ChannelType;
(function (ChannelType) {
    /** Unspecified sales channel. This value is not supported. */
    ChannelType["UNSPECIFIED"] = "UNSPECIFIED";
    /** A web client. */
    ChannelType["WEB"] = "WEB";
    /** [Point of sale solutions](https://support.wix.com/en/wix-mobile-pos-2196395). */
    ChannelType["POS"] = "POS";
    /** [eBay shop](https://support.wix.com/en/article/wix-stores-connecting-and-setting-up-an-ebay-shop). */
    ChannelType["EBAY"] = "EBAY";
    /** [Amazon shop](https://support.wix.com/en/article/wix-stores-connecting-and-setting-up-an-amazon-shop). */
    ChannelType["AMAZON"] = "AMAZON";
    /** Other sales platform. */
    ChannelType["OTHER_PLATFORM"] = "OTHER_PLATFORM";
    /** [Wix Owner app](https://support.wix.com/article/wix-owner-app-an-overview). */
    ChannelType["WIX_APP_STORE"] = "WIX_APP_STORE";
    /** Wix Invoices app in [your dashboard](https://www.wix.com/my-account/site-selector/?buttonText=Select%20Site&title=Select%20a%20Site&autoSelectOnSingleSite=true&actionUrl=https:%2F%2Fwww.wix.com%2Fdashboard%2F%7B%7BmetaSiteId%7D%7D%2Finvoices/settings/general-settings) */
    ChannelType["WIX_INVOICES"] = "WIX_INVOICES";
    /** Wix merchant backoffice. */
    ChannelType["BACKOFFICE_MERCHANT"] = "BACKOFFICE_MERCHANT";
    /** Wish sales channel. */
    ChannelType["WISH"] = "WISH";
    /** [ClassPass sales channel](https://support.wix.com/en/article/wix-bookings-letting-clients-book-your-services-with-classpass). */
    ChannelType["CLASS_PASS"] = "CLASS_PASS";
    /** Global-E sales channel. */
    ChannelType["GLOBAL_E"] = "GLOBAL_E";
    /** [Facebook shop](https://support.wix.com/en/article/wix-stores-changes-to-facebook-shops). */
    ChannelType["FACEBOOK"] = "FACEBOOK";
    /** [Etsy sales channel](https://support.wix.com/en/article/wix-stores-request-adding-etsy-as-a-sales-channel). */
    ChannelType["ETSY"] = "ETSY";
    /** [TikTok sales channel](https://support.wix.com/en/article/wix-stores-request-adding-tiktok-as-a-sales-channel). */
    ChannelType["TIKTOK"] = "TIKTOK";
    /** [Faire marketplace integration](https://support.wix.com/en/article/wix-stores-creating-a-faire-store-using-the-faire-integration-app). */
    ChannelType["FAIRE_COM"] = "FAIRE_COM";
})(ChannelType || (ChannelType = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
/**
 * Creates a new cart.
 *
 *
 * The `createCart()` function returns a Promise that resolves to the new cart when it's created.
 *
 * > **Note:** When adding catalog items, `options.lineItems.catalogReference` is required.
 * @public
 * @requiredField options.customLineItems.descriptionLines.name
 * @requiredField options.customLineItems.descriptionLines.value
 * @requiredField options.customLineItems.itemType
 * @requiredField options.customLineItems.price
 * @requiredField options.customLineItems.productName
 * @requiredField options.customLineItems.quantity
 * @requiredField options.lineItems.catalogReference
 * @requiredField options.lineItems.quantity
 * @requiredField options.lineItems.selectedMembership._id
 * @requiredField options.lineItems.selectedMembership.appId
 * @param options - Cart creation options.
 * @permissionId ECOM.MODIFY_CARTS
 * @permissionId ECOM.ADMIN_MODIFY_CARTS
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage eCommerce - Admin Permissions
 * @permissionScopeId SCOPE.ECOM.MANAGE-ADMIN
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 * @returns Fulfilled - Cart.
 * @fqn com.wix.ecom.cart.api.v1.CartService.CreateCart
 */
export async function createCart(options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({
        cartInfo: options?.cartInfo,
        couponCode: options?.couponCode,
        merchantDiscounts: options?.merchantDiscounts,
        lineItems: options?.lineItems,
        customLineItems: options?.customLineItems,
    }), [
        {
            transformFn: transformSDKPageURLV2ToRESTPageURLV2,
            paths: [
                { path: 'cartInfo.lineItems.url' },
                { path: 'lineItems.url' },
                { path: 'customLineItems.url' },
            ],
        },
        {
            transformFn: transformSDKImageToRESTImage,
            paths: [
                { path: 'cartInfo.lineItems.image' },
                { path: 'cartInfo.lineItems.catalogOverrideFields.image' },
                { path: 'lineItems.image' },
                { path: 'lineItems.catalogOverrideFields.image' },
                { path: 'customLineItems.media' },
            ],
        },
        {
            transformFn: transformSDKAddressToRESTAddress,
            paths: [{ path: 'cartInfo.contactInfo.address' }],
        },
    ]);
    const reqOpts = ambassadorWixEcomV1Cart.createCart(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [{ path: 'cart.lineItems.url' }],
            },
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'cart.lineItems.image' },
                    { path: 'cart.lineItems.catalogOverrideFields.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'cart.contactInfo.address' }],
            },
        ]))?.cart;
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                cartInfo: '$[0].cartInfo',
                couponCode: '$[0].couponCode',
                merchantDiscounts: '$[0].merchantDiscounts',
                lineItems: '$[0].lineItems',
                customLineItems: '$[0].customLineItems',
            },
            singleArgumentUnchanged: false,
        }, ['options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Updates a specified cart's properties.
 *
 * After a cart is updated, call `refreshCart()` to update the cart's UI elements and trigger the `onCartChange()` event.
 *
 * > **Note:** When updating catalog items, `options.lineItems.catalogReference` is required.
 * @public
 * @requiredField _id
 * @requiredField options.customLineItems.descriptionLines.name
 * @requiredField options.customLineItems.descriptionLines.value
 * @requiredField options.customLineItems.itemType
 * @requiredField options.customLineItems.productName
 * @requiredField options.lineItems.catalogReference
 * @param options - Available options to use when updating a cart.
 * @param _id - ID of the cart to be updated.
 * @permissionId ECOM.MODIFY_CARTS
 * @permissionId ECOM.ADMIN_MODIFY_CARTS
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage eCommerce - Admin Permissions
 * @permissionScopeId SCOPE.ECOM.MANAGE-ADMIN
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 * @returns Fulfilled - Updated cart.
 * @fqn com.wix.ecom.cart.api.v1.CartService.UpdateCart
 */
export async function updateCart(_id, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({
        cartInfo: { ...options?.cartInfo, id: _id },
        couponCode: options?.couponCode,
        merchantDiscounts: options?.merchantDiscounts,
        lineItems: options?.lineItems,
        customLineItems: options?.customLineItems,
    }), [
        {
            transformFn: transformSDKPageURLV2ToRESTPageURLV2,
            paths: [
                { path: 'cartInfo.lineItems.url' },
                { path: 'lineItems.url' },
                { path: 'customLineItems.url' },
            ],
        },
        {
            transformFn: transformSDKImageToRESTImage,
            paths: [
                { path: 'cartInfo.lineItems.image' },
                { path: 'cartInfo.lineItems.catalogOverrideFields.image' },
                { path: 'lineItems.image' },
                { path: 'lineItems.catalogOverrideFields.image' },
                { path: 'customLineItems.media' },
            ],
        },
        {
            transformFn: transformSDKAddressToRESTAddress,
            paths: [{ path: 'cartInfo.contactInfo.address' }],
        },
    ]);
    const reqOpts = ambassadorWixEcomV1Cart.updateCart(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [{ path: 'cart.lineItems.url' }],
            },
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'cart.lineItems.image' },
                    { path: 'cart.lineItems.catalogOverrideFields.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'cart.contactInfo.address' }],
            },
        ]))?.cart;
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: { cartInfo: '$[1].cartInfo' },
            explicitPathsToArguments: {
                'cartInfo.id': '$[0]',
                couponCode: '$[1].couponCode',
                merchantDiscounts: '$[1].merchantDiscounts',
                lineItems: '$[1].lineItems',
                customLineItems: '$[1].customLineItems',
            },
            singleArgumentUnchanged: false,
        }, ['_id', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Retrieves a cart.
 *
 *
 * The `getCart()` function returns a Promise that resolves when the specified cart is retrieved.
 * @param _id - ID of the cart to retrieve.
 * @public
 * @requiredField _id
 * @permissionId ECOM.READ_CARTS
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Read eCommerce - all read permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.READ-ECOM
 * @permissionScope Read Orders
 * @permissionScopeId SCOPE.DC-STORES.READ-ORDERS
 * @permissionScope Read Stores - all read permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.READ-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @permissionScope Manage Orders
 * @permissionScopeId SCOPE.DC-STORES.MANAGE-ORDERS
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 * @returns Fulfilled - The specified cart.
 * @fqn com.wix.ecom.cart.api.v1.CartService.GetCart
 */
export async function getCart(_id) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({ id: _id });
    const reqOpts = ambassadorWixEcomV1Cart.getCart(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [{ path: 'cart.lineItems.url' }],
            },
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'cart.lineItems.image' },
                    { path: 'cart.lineItems.catalogOverrideFields.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'cart.contactInfo.address' }],
            },
        ]))?.cart;
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { id: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['_id']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Retrieves the cart associated with a specified checkout.
 * @param _id - Checkout ID.
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @permissionId ECOM.READ_CARTS
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Read eCommerce - all read permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.READ-ECOM
 * @permissionScope Read Orders
 * @permissionScopeId SCOPE.DC-STORES.READ-ORDERS
 * @permissionScope Read Stores - all read permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.READ-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @permissionScope Manage Orders
 * @permissionScopeId SCOPE.DC-STORES.MANAGE-ORDERS
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 * @fqn com.wix.ecom.cart.api.v1.CartService.GetCartByCheckoutId
 */
export async function getCartByCheckoutId(_id) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({ id: _id });
    const reqOpts = ambassadorWixEcomV1Cart.getCartByCheckoutId(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [{ path: 'cart.lineItems.url' }],
            },
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'cart.lineItems.image' },
                    { path: 'cart.lineItems.catalogOverrideFields.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'cart.contactInfo.address' }],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { id: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['_id']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Adds catalog line items to a cart.
 *
 * After a cart is updated, call `refreshCart()` to update the cart's UI elements and trigger the `onCartChange()` event.
 *
 * > **Note:** When adding catalog items, `options.lineItems.catalogReference` is required.
 * @param _id - Cart ID.
 * @public
 * @requiredField _id
 * @requiredField options.customLineItems.descriptionLines.name
 * @requiredField options.customLineItems.descriptionLines.value
 * @requiredField options.customLineItems.itemType
 * @requiredField options.customLineItems.price
 * @requiredField options.customLineItems.productName
 * @requiredField options.customLineItems.quantity
 * @requiredField options.lineItems.catalogReference
 * @requiredField options.lineItems.selectedMembership._id
 * @requiredField options.lineItems.selectedMembership.appId
 * @param options - Items to be added to cart.
 * @permissionId ECOM.MODIFY_CARTS
 * @permissionId ECOM.ADMIN_MODIFY_CARTS
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage eCommerce - Admin Permissions
 * @permissionScopeId SCOPE.ECOM.MANAGE-ADMIN
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 * @returns Fulfilled - Cart.
 * @fqn com.wix.ecom.cart.api.v1.CartService.AddToCart
 */
export async function addToCart(_id, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({
        id: _id,
        lineItems: options?.lineItems,
        customLineItems: options?.customLineItems,
        businessLocationId: options?.businessLocationId,
    }), [
        {
            transformFn: transformSDKPageURLV2ToRESTPageURLV2,
            paths: [{ path: 'lineItems.url' }, { path: 'customLineItems.url' }],
        },
        {
            transformFn: transformSDKImageToRESTImage,
            paths: [
                { path: 'lineItems.image' },
                { path: 'lineItems.catalogOverrideFields.image' },
                { path: 'customLineItems.media' },
            ],
        },
    ]);
    const reqOpts = ambassadorWixEcomV1Cart.addToCart(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [{ path: 'cart.lineItems.url' }],
            },
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'cart.lineItems.image' },
                    { path: 'cart.lineItems.catalogOverrideFields.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'cart.contactInfo.address' }],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                id: '$[0]',
                lineItems: '$[1].lineItems',
                customLineItems: '$[1].customLineItems',
                businessLocationId: '$[1].businessLocationId',
            },
            singleArgumentUnchanged: false,
        }, ['_id', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Removes line items from the specified cart.
 *
 * After a cart is updated, call `refreshCart()` to update the cart's UI elements and trigger the `onCartChange()` event.
 * @public
 * @requiredField _id
 * @requiredField lineItemIds
 * @param lineItemIds - IDs of the line items to remove from the cart.
 * @param _id - ID of the cart to remove line items from.
 * @permissionId ECOM.MODIFY_CARTS
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 * @returns Fulfilled - Updated cart.
 * @fqn com.wix.ecom.cart.api.v1.CartService.RemoveLineItems
 */
export async function removeLineItems(_id, lineItemIds) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        id: _id,
        lineItemIds: lineItemIds,
    });
    const reqOpts = ambassadorWixEcomV1Cart.removeLineItems(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [{ path: 'cart.lineItems.url' }],
            },
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'cart.lineItems.image' },
                    { path: 'cart.lineItems.catalogOverrideFields.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'cart.contactInfo.address' }],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { id: '$[0]', lineItemIds: '$[1]' },
            singleArgumentUnchanged: false,
        }, ['_id', 'lineItemIds']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Creates a checkout from a cart.
 *
 *
 * The `createCheckout()` function returns a Promise that resolves to the new checkout's ID when it's created.
 *
 * If a checkout was already created from the specified cart, that checkout will be
 * updated with any new information from the cart.
 *
 * > **Note:** `options.channelType` is a required field.
 * @param _id - Cart ID.
 * @public
 * @requiredField _id
 * @param options - Checkout creation options.
 * @permissionId ECOM.CREATE_CHECKOUT_FROM_CART
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @permissionScope Manage Orders
 * @permissionScopeId SCOPE.DC-STORES.MANAGE-ORDERS
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 * @returns Fulfilled - ID of the newly created checkout.
 * @fqn com.wix.ecom.cart.api.v1.CartService.CreateCheckout
 */
export async function createCheckout(_id, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({
        id: _id,
        channelType: options?.channelType,
        shippingAddress: options?.shippingAddress,
        billingAddress: options?.billingAddress,
        selectedShippingOption: options?.selectedShippingOption,
        email: options?.email,
    }), [
        {
            transformFn: transformSDKAddressToRESTAddress,
            paths: [{ path: 'shippingAddress' }, { path: 'billingAddress' }],
        },
    ]);
    const reqOpts = ambassadorWixEcomV1Cart.createCheckout(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                id: '$[0]',
                channelType: '$[1].channelType',
                shippingAddress: '$[1].shippingAddress',
                billingAddress: '$[1].billingAddress',
                selectedShippingOption: '$[1].selectedShippingOption',
                email: '$[1].email',
            },
            singleArgumentUnchanged: false,
        }, ['_id', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Removes the coupon from a specified cart.
 *
 * After a cart is updated, call `refreshCart()` to update the cart's UI elements and trigger the `onCartChange()` event.
 * @param _id - Cart ID.
 * @public
 * @requiredField _id
 * @permissionId ECOM.MODIFY_CARTS
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 * @returns Fulfilled - Updated cart.
 * @fqn com.wix.ecom.cart.api.v1.CartService.RemoveCoupon
 */
export async function removeCoupon(_id) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({ id: _id });
    const reqOpts = ambassadorWixEcomV1Cart.removeCoupon(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [{ path: 'cart.lineItems.url' }],
            },
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'cart.lineItems.image' },
                    { path: 'cart.lineItems.catalogOverrideFields.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'cart.contactInfo.address' }],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { id: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['_id']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Updates the quantity of one or more line items in a specified cart.
 *
 * After a cart is updated, call `refreshCart()` to update the cart's UI elements and trigger the `onCartChange()` event.
 *
 * This method is only for updating the quantity of line items. To entirely remove a line item from the cart, use `removeLineItems()`. To add a new line item to the cart, use `addToCart()`.
 *
 * This method checks the amount of stock remaining for this line item. If the specified `quantity` is greater than the remaining stock, then the `quantity` returned in the response is the total amount of remaining stock.
 * @param _id - Cart ID.
 * @param lineItems - Line item IDs and their new quantity.
 * @public
 * @requiredField _id
 * @requiredField lineItems
 * @permissionId ECOM.MODIFY_CARTS
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 * @returns Fulfilled - Updated cart.
 * @fqn com.wix.ecom.cart.api.v1.CartService.UpdateLineItemsQuantity
 */
export async function updateLineItemsQuantity(_id, lineItems) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        id: _id,
        lineItems: lineItems,
    });
    const reqOpts = ambassadorWixEcomV1Cart.updateLineItemsQuantity(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [{ path: 'cart.lineItems.url' }],
            },
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'cart.lineItems.image' },
                    { path: 'cart.lineItems.catalogOverrideFields.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'cart.contactInfo.address' }],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { id: '$[0]', lineItems: '$[1]' },
            singleArgumentUnchanged: false,
        }, ['_id', 'lineItems']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Estimates the subtotal and total for current site visitor’s cart. Totals include tax and are based on the selected carrier service, shipping address, and billing information.
 *
 *
 * The `estimateTotals()` function returns a Promise that resolves when the estimated totals are generated.
 *
 * > **Note:** Not passing any `options` properties will only estimate the cart items price totals.
 * @param _id - Cart ID.
 * @public
 * @requiredField _id
 * @param options - Total estimation options.
 * @permissionId ECOM.READ_CARTS
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Read eCommerce - all read permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.READ-ECOM
 * @permissionScope Read Orders
 * @permissionScopeId SCOPE.DC-STORES.READ-ORDERS
 * @permissionScope Read Stores - all read permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.READ-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @permissionScope Manage Orders
 * @permissionScopeId SCOPE.DC-STORES.MANAGE-ORDERS
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 * @returns Fulfilled - Cart's estimated totals.
 * @fqn com.wix.ecom.cart.api.v1.CartService.EstimateTotals
 */
export async function estimateTotals(_id, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({
        id: _id,
        selectedShippingOption: options?.selectedShippingOption,
        shippingAddress: options?.shippingAddress,
        billingAddress: options?.billingAddress,
        selectedMemberships: options?.selectedMemberships,
        calculateTax: options?.calculateTax,
        calculateShipping: options?.calculateShipping,
    }), [
        {
            transformFn: transformSDKAddressToRESTAddress,
            paths: [{ path: 'shippingAddress' }, { path: 'billingAddress' }],
        },
    ]);
    const reqOpts = ambassadorWixEcomV1Cart.estimateTotals(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [{ path: 'cart.lineItems.url' }],
            },
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'cart.lineItems.image' },
                    { path: 'cart.lineItems.catalogOverrideFields.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [
                    { path: 'cart.contactInfo.address' },
                    {
                        path: 'shippingInfo.selectedCarrierServiceOption.logistics.pickupDetails.address',
                    },
                    {
                        path: 'shippingInfo.carrierServiceOptions.shippingOptions.logistics.pickupDetails.address',
                    },
                ],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                id: '$[0]',
                selectedShippingOption: '$[1].selectedShippingOption',
                shippingAddress: '$[1].shippingAddress',
                billingAddress: '$[1].billingAddress',
                selectedMemberships: '$[1].selectedMemberships',
                calculateTax: '$[1].calculateTax',
                calculateShipping: '$[1].calculateShipping',
            },
            singleArgumentUnchanged: false,
        }, ['_id', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Deletes a cart.
 *
 *
 * The `deleteCart()` function returns a Promise that resolves when the specified cart is deleted.
 * @public
 * @requiredField _id
 * @param _id - ID of the cart to delete.
 * @permissionId ECOM.MODIFY_CARTS
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 * @returns Fulfilled - When the cart is deleted. Rejected - Error message.
 * @fqn com.wix.ecom.cart.api.v1.CartService.DeleteCart
 */
export async function deleteCart(_id) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({ id: _id });
    const reqOpts = ambassadorWixEcomV1Cart.deleteCart(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { id: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['_id']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Removes the location associated with a cart.
 * @param _id - Cart ID.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @permissionId ECOM.MODIFY_CARTS
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 * @fqn com.wix.ecom.cart.api.v1.CartService.RemoveBusinessLocation
 */
export async function removeBusinessLocation(_id) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({ id: _id });
    const reqOpts = ambassadorWixEcomV1Cart.removeBusinessLocation(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [{ path: 'cart.lineItems.url' }],
            },
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'cart.lineItems.image' },
                    { path: 'cart.lineItems.catalogOverrideFields.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [{ path: 'cart.contactInfo.address' }],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { id: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['_id']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
//# sourceMappingURL=ecom-v1-cart-cart.universal.js.map